<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :sm="6" :xxl="4">
              <e-input
                title="姓名"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.CustomerName"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-input
                title="手机号"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.CustomerMobile"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-radio
                title="类型"
                :labelCol="6"
                :valueCol="18"
                v-model:value="queryParams.BillType"
                :options="[
                  {
                    label: '充值',
                    value: 0,
                  },
                  {
                    label: '退费',
                    value: 1,
                  },
                  {
                    label: '消费',
                    value: 10,
                  },
                ]"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="开始时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.BeginDate"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="结束时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.EndDate"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)"> 查询 </a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'customerName'">
              <div class="username">
                <span>{{ record.customerName }}</span>
                <span>({{ ["未知", "先生", "女士"][record.customerSex] }})</span>
                <span v-if="record.customerSex == 1" class="sex man">
                  <ManOutlined />
                </span>
                <span v-else-if="record.customerSex == 2" class="sex feman">
                  <WomanOutlined />
                </span>
                <span v-else class="sex">
                  <ManOutlined />
                </span>
              </div>
            </template>

            <template v-if="column.key === 'createTime'">
              {{ $filters.formatDate(record.createTime) }}
            </template>

            <template v-if="column.key === 'action'">
              <a-tooltip>
                <template #title>账户信息</template>
                <a @click.stop="$refs.finAccount.open(record)">
                  <icon-font type="icon-caiwu1" />
                </a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:current="page.page"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import {
  ManOutlined,
  WomanOutlined
} from '@ant-design/icons-vue'
import { BillClass } from '@/apis/bill'
import page from '@/mixins/page'

const api = new BillClass()
export default defineComponent({
  mixins: [page],
  components: {
    ManOutlined,
    WomanOutlined
  },
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60
      },
      {
        title: '用户',
        key: 'customerName',
        dataIndex: 'customerName',
        width: 200
      },
      {
        title: '手机号码',
        key: 'customerMobile',
        dataIndex: 'customerMobile',
        width: 200
      },
      {
        title: '账单类型',
        key: 'billTypeCN',
        dataIndex: 'billTypeCN',
        width: 100
      },
      {
        title: '金额',
        key: 'money',
        dataIndex: 'money',
        width: 100
      },
      {
        title: '创建时间',
        key: 'createTime',
        dataIndex: 'createTime',
        width: 200
      },
      {
        title: '备注',
        key: 'remark',
        dataIndex: 'remark'
      }
    ]
    return {
      columns,
      loading,
      height,
      width
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      api.gets(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    }
  }
})
</script>

<style lang="less" scoped>
.username {
  display: flex;
  align-items: center;
  img {
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #ccc;
  }
  span {
    margin-left: 5px;
    &.sex {
      font-size: 12px;
      color: #ccc;
      &.man {
        color: rgb(66, 48, 228);
      }
      &.feman {
        color: rgb(228, 48, 48);
      }
    }
  }
}
</style>
